import { render, staticRenderFns } from "./VisitDetails.vue?vue&type=template&id=2d09a84d&"
import script from "./VisitDetails.vue?vue&type=script&lang=js&"
export * from "./VisitDetails.vue?vue&type=script&lang=js&"
import style0 from "./VisitDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports